import React, { useState, useEffect } from 'react';
import Sidebar from '../sidebar';
import CommunityManageNav from '../community_manage_nav';
import Overview from './overview';
import Access from './access';
import MembershipFees from './membership_fees';
import TrialPeriod from './trial_period';
import { getSearchParams } from '../../ajax_utils';

const SettingsSection = ({ initCommunity }) => {
  const sidebarOptions = [
      'overview',
      'access'
  ];
  const initTab = getSearchParams(sidebarOptions);
  const [tab, setTab] = useState(initTab);
  const [community, setCommunity] = useState(initCommunity);

  useEffect(() => {
    setCommunity(community);
  }, [community]);

  return (
    <div className="communities v2">
      <CommunityManageNav name={community.name} />
      <section className="mt-6 mt-md-8 settings">
        <div className="container-xxl">
          <div className="row justify-content-between">
            <Sidebar
              options={sidebarOptions}
              pending={0}
              setTab={setTab}
              tab={tab}
            />
            <div className="col-md-2 col-lg-3 sidebar-placeholder"></div>
            <main className="col-12 col-md-8 col-lg-9 mt-4 mt-md-0 ps-lg-6">
              <Overview show={tab === 'overview'} community={community} setCommunity={setCommunity} />
              <Access show={tab === 'access'} community={community} setCommunity={setCommunity} />
              <MembershipFees show={tab === 'membership fees'} community={community} setCommunity={setCommunity} />
              <TrialPeriod show={tab === 'trial period'} community={community} setCommunity={setCommunity} />
            </main>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SettingsSection;
